export default __webpack_public_path__ + "static/media/Tt.91c057a1.png";